import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row } from "reactstrap";

class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <SEO
          title={
            "On demand truck and driver hire transportation service. Local truck/bakkie hire and couriers at affordable prices."
          }
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Move your goods with our delivery vehicles and drivers. Furniture, Equipment, Construction Materials and more! Review your instant online quotation now. On demand truck and driver hire transportation service."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/vacancies"}
          twitterUsername={"qiktrucksa"}
        />
        <section id="home">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <div className="hero-wrapper mb-4 about-us">
                  <h1 id="about" style={{textAlign: "left"}}>Careers at QikTruck</h1>
                  <p className="quote">
                    Build the future of on‑demand logistics. Join a fast‑moving team
                    shaping how goods move across South Africa.
                  </p>
                  <div className="badges" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 8 }}>
                    <span className="badge badge-success">Full‑time & Internships</span>
                    <span className="badge badge-info">Hybrid & On‑site</span>
                    <span className="badge badge-primary">Ops • Tech • Growth</span>
                  </div>

                  <div className="cta" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 16 }}>
                    <a
                      className="btn btn-primary"
                      href="https://careers.qiktruck.co.za"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Explore Openings
                    </a>
                    <a
                      className="btn btn-outline-secondary"
                      href="/in-service-training"
                      rel="noopener noreferrer"
                    >
                      In‑Service Training
                    </a>
                  </div>

                  <hr style={{ margin: "24px 0" }} />

                  <h4>Open Roles</h4>
                  <div className="cards" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 16 }}>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Finance Intern</h5>
                        <span className="badge badge-light">Internship</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Logistics Administrator</h5>
                        <span className="badge badge-light">Operations</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Sales & Logistics Administrator</h5>
                        <span className="badge badge-light">Operations</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Online Sales Administrator</h5>
                        <span className="badge badge-light">Growth</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Field Agent – Sales Representative</h5>
                        <span className="badge badge-light">Growth</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Social Media Manager</h5>
                        <span className="badge badge-light">Marketing</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Social Media Influencer</h5>
                        <span className="badge badge-light">50K+ followers</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">ReactJS Developer</h5>
                        <span className="badge badge-light">Engineering</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">NodeJS Developer</h5>
                        <span className="badge badge-light">Engineering</span>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">In‑Service Training</h5>
                        <span className="badge badge-light">TVET & UoT</span>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: 16 }}>
                    <a
                      className="btn btn-link"
                      href="https://careers.qiktruck.co.za"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View details and apply →
                    </a>
                  </div>

                  <hr style={{ margin: "24px 0" }} />

                  <h4>Partnerships</h4>
                  <div className="cards" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 16 }}>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Vehicle Finance</h5>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Vehicle Maintenance</h5>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Vehicle Cleaning</h5>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Vehicle Parts Supplier</h5>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Vehicle Fuel Supplier</h5>
                      </div>
                    </div>
                    <div className="card modern-card">
                      <div className="card-body">
                        <h5 className="card-title">Real Estate Agent Discounts</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
